/**
 * Formats a Date object to YYYY-MM-DD string using local timezone.
 * Avoids the UTC shift bug caused by toISOString().split('T')[0].
 */
export function toLocalDateString(date) {
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date; // Already a YYYY-MM-DD string, return as-is
  }
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
